export class CallApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCallActivities({ applicationId, signal }) {
    return this.#http.get('/api/call/applicationCallHistory', {
      params: { applicationId },
      signal,
    });
  }

  async updateCallNotes({ callHistoryId, callNotes }) {
    return this.#http.post('/api/call/callNotes', {
      callHistoryId,
      callNotes,
    });
  }

  async updateCallOutcome({ callHistoryId, callDisposition }) {
    return this.#http.put(`/api/call/${callHistoryId}`, {
      CallDisposition: callDisposition,
      Type: 'Disposition',
    });
  }
}
